import React, { useEffect, useState } from 'react';

import StyledLogo from '../../components/logo';
import {
    Title, Paragraph, OfferContainer, Stamp,
    DescriptionContainer, Separator, OfferTitle, OfferLink, OfferLinkText,
    RightArrowContainer, OfferContentContainer, StampContainer, 
    IconTitleContainer, DesktopContinueButton, MobileCardHeader, 
    CardHeaderTitle, IconTitleDesktop, IconTitleMobile, CardHeaderIcon, 
    OfferMainImage, StampInnerCircle, StampContentContainer, 
    MobileContinueButtonContainer, MobileContinueButton, CallMeButton,
    CallMeLabel,
} from './components';
import { ButtonIconWrapper } from '../../components/Buttons/style';

import { LinkOutsideSite } from '../../components/Buttons';
import { ButtonLabel } from '../../components/Buttons/labels';
import { THEME_COLORS } from '../../styles/theme';
import { getTrackingInfoOffer } from '../../tracking/getTrackingInfoOffer';
import { PERSONAL_DATA_FORM_FIELDS_NAMES } from '../../reducers/personalDataForm';
import { SUPPLY_ADDRESS_FORM_FIELD_NAMES } from '../../reducers/supplyAddressForm';
import { CONSENT_FORM_FIELD_NAMES } from "../../reducers/consentForm";
import { setTrackerScript } from '../../tracking/setTracker';
import { ReactComponent as ArrowRight } from '../../static/images/orion-arrow-right.svg';
import { ReactComponent as ConfirmationSVG } from '../../static/images/confirmation.svg';
import { ReactComponent as ConfirmationSmallSVG } from '../../static/images/ConfirmationSmall.svg';
import HeroBlob from "../../components/HeroBlob";
import { Icons } from '../../components/Icons';
import {DataLayerContainerEndPage} from "../../components/DataLayer";
import {MgmTracking} from "../../components/MgM";

const Blob = React.memo(() => (
    <div style={{ height: '50px' }}>
        <HeroBlob />
    </div>
));

export default props => {
    const [isImageLoaded, setIsImageLoaded] = useState(false);
    const texts = props.textsReducer.texts;
    const shouldShowImage = !!texts.title;


    useEffect(() => {

        setTrackerScript({
            firstStep: props.personalDataForm,
            secondStep: props.supplyAddressForm,
            trackName: 'vivigas|x|funnel|thankyoupage',

            ...getTrackingInfoOffer(props.offer),
            customObjectTracking: {
                sv4: props.personalDataForm[PERSONAL_DATA_FORM_FIELDS_NAMES.name],
                sv5: props.personalDataForm[PERSONAL_DATA_FORM_FIELDS_NAMES.surname],
                sv6: props.personalDataForm[PERSONAL_DATA_FORM_FIELDS_NAMES.mobilePhone],
                sv7: props.supplyAddressForm[SUPPLY_ADDRESS_FORM_FIELD_NAMES.pod],
                sv8: props.supplyAddressForm[SUPPLY_ADDRESS_FORM_FIELD_NAMES.pdr],
                sv9: props.personalDataForm[PERSONAL_DATA_FORM_FIELDS_NAMES.email],
                orderid: props.globalFormFieldsReducer.userId
            }
        });
    }, []);


    return (
        <div>
            <Blob />
            <MgmTracking  {...props.globalFormFieldsReducer} {...props.offer} {...props.personalDataForm} />
            <DataLayerContainerEndPage {...props.globalFormFieldsReducer} {...props.consentForm} {...props.offer} {...props.personalDataForm} {...props.supplyAddressForm} ></DataLayerContainerEndPage>
            <div className="container">
                <div className="row">
                    <div className="col-12 col-xl-11 offset-xl-1">
                        <StyledLogo />
                    </div>
                </div>

                <div className="row">
                    <div className={!shouldShowImage ? "col-12 col-lg-10 col-xl-7 offset-lg-1 offset-xl-3" : "col-12 col-xl-11 offset-xl-1"}>
                        <IconTitleContainer>
                            <IconTitleDesktop>
                                <ConfirmationSVG />
                            </IconTitleDesktop>
                            <IconTitleMobile>
                                <ConfirmationSmallSVG />
                            </IconTitleMobile>
                            <Title>Grazie per averci scelto!</Title>
                        </IconTitleContainer>
                    </div>
                </div>

                <div className="row">
                    <div className={shouldShowImage ? "col-12 col-lg-7 col-xl-6 offset-xl-1" : "col-12 col-lg-10 col-xl-7 offset-lg-1 offset-xl-3"}>
                        <Paragraph
                            dangerouslySetInnerHTML={{ __html: texts.finalMessage }}
                            shouldShowImage={shouldShowImage}
                        ></Paragraph>
                        <DesktopContinueButton shouldShowImage={shouldShowImage}>
                            <LinkOutsideSite
                                href="https://www.vivigas.it/"
                                mainColor={THEME_COLORS.pinkOrange}
                                hasOnlyOutline={true}
                                textColor={THEME_COLORS.red}
                                to="/"
                            >
                                <ButtonLabel color={THEME_COLORS.red}>Torna alla Home Page</ButtonLabel>
                            </LinkOutsideSite>
                        </DesktopContinueButton>
                    </div>

                    <MobileContinueButtonContainer style={{maxWidth: "181px", margin:"auto"}}>
                        <LinkOutsideSite
                            href="https://www.vivigas.it/"
                            mainColor={THEME_COLORS.pinkOrange}
                            hasOnlyOutline={true}
                            textColor={THEME_COLORS.red}
                            to="/"
                        >
                            <ButtonLabel  color={THEME_COLORS.red}>Torna alla Home Page</ButtonLabel>
                        </LinkOutsideSite>
                    </MobileContinueButtonContainer>

                    {shouldShowImage && <div className="col-12 col-md-6 col-lg-4 offset-md-3 offset-lg-1">
                        <OfferContainer>
                            {isImageLoaded && <><StampContainer>
                                <Stamp>
                                    {/* <img src={texts.stamp} width="116px" height="116px" /> */}
                                    <StampInnerCircle />
                                    <StampContentContainer>
                                        {texts.stampIcons &&
                                            <CardHeaderIcon
                                                src={texts.stampIcons}

                                            />
                                        }
                                        <CardHeaderTitle>
                                            {texts.cardTitle}
                                        </CardHeaderTitle>
                                    </StampContentContainer>
                                </Stamp>
                            </StampContainer>
                                <MobileCardHeader>
                                    {texts.stampIcons &&
                                        <CardHeaderIcon src={texts.stampIcons} />
                                    }
                                    <CardHeaderTitle>
                                        {texts.cardTitle}
                                    </CardHeaderTitle>
                                </MobileCardHeader></>}

                            <OfferMainImage
                                src={texts.image}
                                onLoad={() => setIsImageLoaded(true)}
                            />

                            {isImageLoaded && <OfferContentContainer>
                                <DescriptionContainer dangerouslySetInnerHTML={{ __html: texts.description }} />
                                <Separator />
                                <OfferTitle>{texts.title}</OfferTitle>
                                {texts.linkCta && <OfferLink href={texts.linkCta}>
                                    <OfferLinkText>{texts.textCta}</OfferLinkText>
                                    <RightArrowContainer>
                                        <ArrowRight />
                                    </RightArrowContainer>
                                </OfferLink>}

                                {texts.isCallMeBackVisible && <CallMeButton
                                    mainColor={THEME_COLORS.greenBlue}
                                    onClick={() => {
                                        props.toggleCallMeBack({
                                            submitSuccessTrackName: 'vivigas|x|funnel|thankyoupage|click_conferma',
                                            submitStartTrackName: "vivigas|x|funnel|thankyoupage|thankyou_richiamami"
                                        })
                                    }}
                                >
                                    <ButtonIconWrapper>
                                        <Icons icon="CallCenter" color={THEME_COLORS.white} />
                                    </ButtonIconWrapper>
                                    <CallMeLabel>
                                        Ti Chiamiamo noi
                                </CallMeLabel>
                                </CallMeButton>}
                            </OfferContentContainer>}
                        </OfferContainer>
                    </div>}
                </div>
            </div>
        </div>
    );
}